// 俄罗斯
module.exports = {
  validate: {
    noEmail:
      "Поле электроннай пошты не можа быць пустым, увядзіце яго яшчэ раз",
    noPhone:
      "Нумар тэлефона не можа быць пустым, калі ласка, увядзіце паўторна",
    errorReg:
      "Даўжыня ўводу 1-50 лічбаў, можна ўводзіць вялікія і малыя літары, лічбы, сімвалы - . _ @",
    noPassword: "Пароль не можа быць пустым, увядзіце яго яшчэ раз",
    pwdReg:
      "Даўжыня ўводнага пароля складае 8-32 лічбаў, ён павінен утрымліваць толькі лічбы і літары",
    pwdCheck:
      "Два ўведзеныя паролі не супадаюць, калі ласка, увядзіце яшчэ раз",
    pwdLengthReg: "Даўжыня пароля ад 8 да 32, калі ласка, пацвердзіце ўвод",
    noCode: "калі ласка, увядзіце праверачны код",
    codeReg: "Калі ласка, увядзіце 6-значны код спраўджання",
    nullText: "Увод не можа быць пустым, калі ласка, увядзіце паўторна",
    phoneCheck:
      "Нумар тэлефона, уведзены двойчы, не адпавядае, калі ласка, увядзіце яшчэ раз",
    emailNumReg:
      "Даўжыня электроннага ліста складае 6-50 сімвалаў, калі ласка, увядзіце паўторна",
    emailReg: "Няправільны адрас электроннай пошты, увядзіце паўторна",
    emailCheck:
      "Двойчы ўведзены ўліковы запіс электроннай пошты супярэчыць, калі ласка, увядзіце паўторна",
    noUsername:
      "Пароль не можа ўтрымліваць нумар рахунку, калі ласка, увядзіце паўторна",
    accountReg:
      "Імя ўліковага запісу ўведзена няправільна, увядзіце яго яшчэ раз",
  },
  area: {
    areaTitle: "Кіраванне раёнам",
    add: "Дадаць вобласць",
    area: "плошча",
    addNextArea: "Стварыць новую падпарадкаваную вобласць",
    areaNameTip: "Калі ласка, увядзіце назву рэгіёна",
    areaNameHold:
      "Даўжыня ўводу складае 1-20 лічбаў, спецыяльныя сімвалы ўводзіць нельга",
    areaNumHold:
      "Даўжыня ўводу складае 1-4 лічбы, можна ўводзіць толькі лічбы, дыяпазон нумароў 0-9999",
    areaNumTip: "Калі ласка, увядзіце нумар вобласці",
    areaName: "Назва вобласці",
    checkAreaName:
      "Назва вобласці не можа быць пустой, калі ласка, увядзіце паўторна",
    areaNameTip1: "Назва вобласці не можа быць пустой",
    areaNameTip2: "Няправільная назва вобласці, калі ласка, увядзіце паўторна",
    areaNum: "Нумар вобласці",
    checkAreaNum:
      "Ідэнтыфікатар зоны не можа быць пустым, калі ласка, увядзіце паўторна",
    lastLevel: "Належыць да вышэйшага раёна",
    checkLastLevel:
      "Вобласць верхняга ўзроўню, да якой ён належыць, не можа быць пустой, абярыце яшчэ раз",
    lastLevelTip:
      "Калі ласка, абярыце бацькоўскую вобласць, да якой вы належыце",
    delInfo:
      "Выкананне гэтай задачы па выдаленні прывядзе да выдалення даных у гэтай вобласці і не можа быць адноўлена",
    oneStep: "першы ўзровень",
    twoStep: "другасны",
    threeStep: "Узровень 3",
    fourStep: "Узровень 4",
    fiveStep: "Узровень 5",
    delAreaTip: "Ёсць падпарадкаваная вобласць, якую немагчыма выдаліць",
    personArea: "Чалавек не прывязаны да раёна",
    areaType: "Дадаць метад",
    addArea1: "Дадаць асобна",
    addArea2: "бесперапыннае складанне",
    addArea3: "Складанне матрыцы",
    areaNameTop: "Прэфікс назвы зоны",
    areaNameLast: "Суфікс назвы зоны",
    areaJoinHold: "Калі ласка, увядзіце прэфікс даменнага імя",
    areaJoinHold1: "Калі ласка, увядзіце суфікс назвы вобласці",
    startNum: "Стартавы нумар",
    checkStartNum:
      "Пачатковы ўведзены нумар няправільны, калі ласка, увядзіце паўторна",
    checkStartNum1:
      "Пале для стартавага нумара не можа быць пустым, калі ласка, увядзіце паўторна",
    checkEndNum:
      "Уведзены канчатковы нумар няправільны, калі ласка, увядзіце паўторна",
    checkEndNum1:
      "Канцавы нумар не можа быць пустым, калі ласка, увядзіце паўторна",
    endNum: "Канец нумара",
    topStart: "Пачатковы нумар загалоўка",
    checkTopStart:
      "Уведзены першы стартавы нумар няправільны, увядзіце яго яшчэ раз",
    checkTopStart1:
      "Увод першага стартавага нумара не можа быць пустым, калі ласка, увядзіце паўторна",
    topEnd: "Канечны нумар загалоўка",
    checkTopEnd:
      "Увядзіце канчатковы нумар загалоўка няправільны, увядзіце паўторна",
    checkTopEnd1:
      "Увод першага канчатковага нумара не можа быць пустым, калі ласка, увядзіце паўторна",
    lastStart: "Пачатковы нумар хваста",
    checkLastStart:
      "Уведзены няправільны стартавы нумар, калі ласка, увядзіце паўторна",
    checkLastStart1:
      "Калі ласка, увядзіце стартавы нумар, калі ласка, увядзіце паўторна",
    lastEnd: "Нумар канца следу",
    checkLastEnd:
      "Увядзіце канчатковы нумар хваста няправільны, калі ласка, увядзіце яшчэ раз",
    checkLastEnd1:
      "Увод апошняга нумара не можа быць пустым, калі ласка, увядзіце паўторна",
    topTip:
      "Даўжыня ўводу складае 1-2 лічбы, можна ўводзіць толькі лічбы, а дыяпазон нумароў 1-99",
    lastTip:
      "Даўжыня ўводу складае 1-2 лічбы, можна ўводзіць толькі лічбы, а дыяпазон нумароў 1-99",
    areaNameTest: "Прыклад назвы вобласці",
  },
  addressBook: {
    config: "Канфігурацыя праекта",
    errorTip: "Памылка фармату адраснай кнігі",
    upgrade: "Кіраванне абнаўленнем адраснай кнігі",
    deviceIdTip: "Калі ласка, увядзіце ідэнтыфікатар прылады",
    deviceId: "Ідэнтыфікатар прылады",
    syncAll: "Сінхранізаваць усё",
    sync: "Сінхранізаваць",
    sysVersion: "Бягучая версія сістэмнай адраснай кнігі",
    deviceVersion: "Бягучая версія адраснай кнігі прылады",
    syncTip: "Паспяхова аддадзена сінхронная каманда",
  },
  newarea: {
    add: "Дадаць вобласць",
    edit: "Вобласць рэдагавання",
    smallTip:
      "На дадзены момант самы маленькі ўзровень вобласці, дадатковыя падзоны дадаваць нельга",
    batch: "Вобласць пакетнага дадання",
    batch1: "бесперапыннае складанне",
    batch2: "Складанне матрыцы",
  },
  deviceSip: {
    saveTip:
      "Калі ласка, своечасова экспартуйце адрасную кнігу, у адваротным выпадку ўсе дадзеныя будуць выдалены пасля выхаду са старонкі.",
    devMsg: "Інфармацыя аб прыладзе",
    list: "Спіс прылад",
    add: "Дадаць прыладу",
    edit: "Рэдагаваць прыладу",
    batch: "Дадаць прылады ў пакетах",
    areaChosen: "Выбар ўзроўню вобласці",
    areaNum: "Колькасць новых дададзеных прылад у кожнай вобласці",
    bacthTip:
      "Калі ўзровень вобласці абраны ў якасці будынка і колькасць новых прылад у кожнай вобласці роўная 4, гэта азначае, што ў кожную створаную вобласць дадаецца 4 прылады",
    note: "праілюстраваць",
    baseConfig: "Асноўная канфігурацыя інфармацыі",
    deviceName: "Імя прылады",
    nameTip:
      "Выпраўлена даданне нумара да назвы групы, да якой ён належыць, напрыклад, Будынак 1-1",
    function: "Функцыя падтрымкі прылады",
    net: "Канфігурацыя сеткі",
    netType: "Тып сеткі",
    netTip1:
      "Static - гэта статычная сетка, вам трэба ўручную ўсталяваць IP і іншую інфармацыю.",
    netTip2:
      "DHCP — гэта дынамічная сетка, і такая інфармацыя, як IP, аўтаматычна прызначаецца маршрутызатарам.",
    mask: "Калі ласка, увядзіце маску падсеткі",
    gateway: "Калі ласка, увайдзіце ў шлюз",
    ip: "Калі ласка, увядзіце IP-адрас",
    ipTip:
      "Уваходны IP-адрас павінен пазбягаць спецыяльнага IP, напрыклад 127.0.0.1 і г.д.",
    dns1: "Калі ласка, увядзіце DNS1",
    dns2: "Калі ласка, увядзіце DNS2",
    sip1: "канфігурацыя інфармацыі sip1",
    config: "Канфігурацыя інфармацыі",
    mode: "мадэль",
    mode1: "Прамы рэжым",
    mode2: "Рэжым сервера",
    user: "калі ласка, увядзіце імя карыстальніка",
    userTitle: "імя карыстальніка",
    userTip: "Па змаўчанні да назвы групы дадаецца лічба, напрыклад 1-1-1",
    last: "Калі ласка, увядзіце суфікс акаўнта",
    sipTip:
      "Калі ласка, увядзіце зарэгістраванае імя карыстальніка і пароль SIP-сервера",
    password: "Калі ласка, увядзіце пароль",
    passwordTitle: "пароль",
    serverIp: "Калі ласка, увядзіце serverIP",
    protocolType: "Калі ласка, абярыце тып пратаколу",
    protocolTypeTitle: "тып пагаднення",
    sip2: "канфігурацыя інфармацыі sip2",
    more: "Больш",
    close: "закрыццё",
    formatError: "Памылка фармату, увядзіце паўторна",
    forbidTip: "Забаронены ўвод 127.0.0.1, увядзіце паўторна",
    call: "Заходзь і звані",
    monitor: "манітор",
    lift: "Кіраванне ліфтам",
    rtsp: "відэапаток rtsp",
    deviceTip:
      "Функцыя падтрымкі прылады не можа быць пустой, абярыце яшчэ раз",
    maskTip1: "Маска падсеткі не можа быць пустой, увядзіце яе яшчэ раз",
    maskTip2:
      "Фармат маскі падсеткі няправільны, калі ласка, увядзіце паўторна",
    gatewayTip1: "Шлюз не можа быць пустым, калі ласка, увядзіце паўторна",
    gatewayTip2: "Памылка фармату шлюза, увядзіце паўторна",
    ipTip1: "IP-адрас не можа быць пустым, калі ласка, увядзіце паўторна",
    ipTip2:
      "Памылка фармату IP-адраса, верхняя мяжа 255.254.254.253, першы абзац не роўны 0, увядзіце паўторна",
    dns1Tip1: "DNS1 не можа быць пустым, калі ласка, увядзіце паўторна",
    dns1Tip2: "Памылка фармату DNS1, увядзіце паўторна",
    dns2Tip1: "Памылка фармату DNS2, увядзіце паўторна",
    passwordTip1: "Пароль не можа быць пустым, увядзіце яго яшчэ раз",
    serviceTip1: "serviceIp не можа быць пустым, калі ласка, увядзіце паўторна",
    serviceTip2: "памылка фармату serviceIp, увядзіце паўторна",
    sip2Tip:
      "У цяперашні час вы наладзілі інфармацыю sip2, запоўніце яе ў адпаведнасці з правіламі",
    devnameTip1:
      "Імя прылады не можа быць пустым, калі ласка, увядзіце паўторна",
    devnameTip2: "Памылка фармату назвы прылады, увядзіце паўторна",
    nameTip1: "Імя карыстальніка не можа быць пустым, абярыце яшчэ раз",
    nameTip2: "Імя карыстальніка не можа быць пустым, абярыце яшчэ раз",
    maxTip1:
      "Колькасць прылад у бягучай вобласці дасягнула верхняга ліміту ў 8, і больш нельга дадаваць",
    area: "плошча",
    editArea: "Вобласць рэдагавання",
    addArea: "Дадаць вобласць",
    batchArea: "Вобласць пакетнага дадання",
    deleteArea: "Выдаліць рэгіён",
    areaName: "Назва вобласці",
    areaNo: "Нумар вобласці",
    importAddr: "Імпартаваць адрасную кнігу",
    next: "Наступны крок",
    areaTip1: "Калі ласка, абярыце вобласць для рэдагавання першай",
    areaTip2: "Калі ласка, спачатку абярыце вобласць, якую трэба выдаліць",
    areaTip3:
      "Ваша бягучая вобласць пустая, зараз вы не можаце дадаваць прылады групамі, спачатку дадайце інфармацыю аб вобласці",
    noArea: "Пакуль няма канфігурацыі зоны",
    error: "Выключэнне дадзеных",
    addDevice: "Дадаць прыладу",
    editDevice: "Рэдагаваць прыладу",
    delDevice: "Выдаліць прыладу",
    batchDevice: "Дадаць прылады ў пакетах",
    prev: "Папярэдні",
    updateAddr: "Абнавіць адрасную кнігу прылады",
    saveAddr: "Захаваць адрасную кнігу",
    exportAddr: "Экспартаваць адрасную кнігу",
    deleteTip: "Ці выдаляць прыладу",
    deleteTip2:
      "У цяперашні час абраны ў якасці рэгіёну, калі ласка, вярніцеся да канфігурацыі рэгіёну, каб выдаліць",
    deleteTip3: "Калі ласка, спачатку абярыце прыладу, якую трэба выдаліць",
    deviceTip1: "Калі ласка, абярыце прыладу для рэдагавання першай",
    deviceTip2: "Калі ласка, спачатку абярыце рэгіён, потым дадайце прыладу",
    exportSuccess: "Экспарт удаўся",
    xmlTip: "Калі ласка, загрузіце xml-файл адраснай кнігі",
    xmlTip1: "Калі ласка, абярыце файл xml для загрузкі",
    xmlTip2:
      "Імпартаваная адрасная кніга не адпавядае бягучаму ўзроўню супольнасці, і імпарт не ўдаўся",
    areaConfig: "Канфігурацыя зоны",
    deviceConfig: "Канфігурацыя прылады",
    exportConfig: "Папярэдні прагляд экспарту",
    projectConfig: "Канфігурацыя праекта",
    prevArea: "Належыць да вышэйшага раёна",
    areaNoTip:
      "Пачатковы нумар большы за канчатковы, калі ласка, запоўніце яшчэ раз",
    smallAreaTip:
      "На дадзены момант самы маленькі ўзровень вобласці, дадатковыя падзоны дадаваць нельга",
    areaNoTip1:
      "Пачатковы нумар першай часткі большы за канчатковы нумар першай часткі, калі ласка, запоўніце яшчэ раз",
    areaNoTip2:
      "Пачатковы нумар хваста большы за канчатковы нумар хваста, калі ласка, запоўніце яшчэ раз",
  },
  push: {
    list: "Націснуць запіс",
    productType: "Нумар прадукту",
    softwareName: "назва праграмнага забеспячэння",
    versionNo: "нумар версіі",
    time: "Час націску",
    invalidTime: "Час заканчэння тэрміну дзеяння",
    upgrade: "абнаўленне",
    upgradeRecord: "Праглядзець запіс абнаўлення",
    deviceType: "Тып абсталявання",
    deviceName: "Імя прылады",
    currentSoftName: "Назва бягучага праграмнага забеспячэння прылады",
    currentSoftNo: "Нумар бягучай версіі прылады",
    upgradeNo: "Нумар версіі праграмнага забеспячэння абнаўлення",
    filterTip1: "Калі ласка, увядзіце назву прылады",
    filterTip2: "Калі ласка, абярыце назву праграмнага забеспячэння",
    filterTip3: "Калі ласка, абярыце нумар версіі",
    checkTip: "Актываваць галачку",
    ota: "Абнаўленне OTA",
    taskName: "назва місіі",
    taskNameTip: "Калі ласка, увядзіце назву задачы",
    binName: "Назва прашыўкі",
    upgradeType: "Метад абнаўлення задачы",
    done: "Ці выконваць неадкладна",
    upgradeTime: "час абнаўлення",
  },
  check: {
    submit: "Віншуем, адпраўка прайшла паспяхова!",
    noSubmit: "На жаль, адпраўка не атрымалася!",
    file: "Выбраць дакумент",
    noFile: "Файл не выбраны",
    projectName: "назва праекта",
    projectNameTip: "Калі ласка, увядзіце назву праекта",
    describe: "апісаць",
    contentTip: "Калі ласка, увядзіце змест",
    areaType: "Іерархія рэгіёнаў",
    example: "Напрыклад: нумар будынка-адзінкі-пакоя",
    areaTip:
      "Фармат нумара вобласці няправільны, калі ласка, увядзіце паўторна",
    areaNameTip: "Калі ласка, увядзіце назву пласта",
    nameTip: "Імя не можа быць пустым, калі ласка, увядзіце паўторна",
    nameError: "Імя было ўведзена няправільна, увядзіце яго яшчэ раз",
    nameLength:
      "Даўжыня ўведзенага імя складае 4~50, калі ласка, увядзіце паўторна",
    areaNullTip: "Узровень вобласці не можа быць пустым",
    formateError: "Даўжыня 1-6 лічбаў, спецыяльныя сімвалы ўводзіць нельга",
    noAreaTip: "Узровень вобласці не можа быць пустым, абярыце яшчэ раз",
    maxFileTip: "Памер файла перавышае ліміт",
    xmlTip: "Калі ласка, загрузіце файл у фармаце XML",
  },
  book: {
    areaBy: "Вобласць",
    list: "Спіс дублікатаў інфармацыі аб прыладзе",
    repeatTip:
      "Наступная інфармацыя аб абсталяванні дубліруецца. Калі ласка, змяніце дубліраваную інфармацыю аб абсталяванні. Пасля націску ,  Пацвердзіць будзе ацэнена дубліраванне ўведзенай інфармацыі аб абсталяванні. ",
    coverTip:
      "Гэтая аперацыя перазапіша даныя пакетнага дадання абранага ўзроўню",
    batchTip: "Дыяпазон IP-адрасоў ствараецца шляхам дадання прылад пакетамі",
  },
  updateNewSip: {
    otaDeleteTip:
      "Не атрымалася выдаліць, можна выдаліць толькі незапушчаныя задачы",
    deleteArea1: "Ці выдаляць рэгіён",
    deleteArea2:
      "У той жа час усе вобласці і прылады ніжэй гэтай вобласці будуць выдалены разам",
    codeRepeatTip:
      "Ідэнтыфікатар рэгіёна таго ж узроўню не можа быць паўтораны, увядзіце паўторна ідэнтыфікатар рэгіёна",
    nameRepeatTip:
      "Назвы абласцей на адным узроўні не могуць быць дубляваныя, калі ласка, увядзіце бягучую назву рэгіёна яшчэ раз",
    deviceIp: "IP прылады",
    callin: "Выклік",
    callout: "выдых",
    systemMsg: "сістэмная інфармацыя",
    batchIpTip:
      "Дыяпазон IP-адрасоў ствараецца шляхам дадання прылад пакетамі на гэты раз",
    ip: "IP-адрас",
    mask: "Маска падсеткі",
    gateway: "Шлюз",
    noData: "Не",
    noAddressTip:
      "У цяперашні час няма дадзеных адраснай кнігі, якія можна сінхранізаваць",
    operator: "Аператар",
    goTip: "Націсніце, каб перайсці да адпаведнага кроку",
    deviceNameTip:
      "Даўжыня ўводу складае 1-16 лічбаў, спецыяльныя сімвалы ўводзіць нельга",
    filter1: "Увядзіце назву вобласці для фільтрацыі",
    filter2: "Увядзіце назву вобласці або назву прылады для фільтрацыі",
    secret: "Пароль шыфравання",
    secretTip:
      "Калі ласка, увядзіце пароль у межах 32 сімвалаў, фармат не абмежаваны",
    noSecretTip: "Неўсталяваны пароль шыфравання можна ігнараваць",
    setSecret: "Усталяваць пароль шыфравання адраснай кнігі",
    ignore: "грэбаванне",
    emptyBookTip: "Адрасная кніга пустая і не можа быць часова экспартавана",
    errorSecret: "Памылка пароля шыфравання адраснай кнігі, увядзіце паўторна",
    other: "іншы",
    doorAuth: "Кіраванне доступам",
    funTitle:
      "Калі ласка, праверце функцыі, якія падтрымліваюцца дададзенай вамі прыладай",
    callInTip: "Выклік службы падтрымкі прылады",
    callOutTip: "Называецца падтрымка прылады",
    monitorTip: "Прылада падтрымлівае маніторынг",
    doorTip: "Прылада падтрымлівае функцыю разблакоўкі",
    liftTip: "Прылада кіравання ліфтам",
    maskTip:
      "Калі ласка, увядзіце маску падсеткі, спасылка на фармат: 255.255.255.255",
    gatewayTip: "Калі ласка, увядзіце шлюз, спасылка на фармат: 1.1.1.1",
    ip1: "Калі ласка, увядзіце IP-адрас, спасылка на фармат: 1.1.1.1",
    ipTip:
      "Уваходны IP-адрас павінен пазбягаць спецыяльнага IP, напрыклад 127.0.0.1 і г.д.",
    dns1: "Калі ласка, увядзіце DNS1, спасылка на фармат: 1.1.1.1",
    dns2: "Калі ласка, увядзіце DNS2, спасылка на фармат: 1.1.1.1",
    serverIp:
      "Калі ласка, увядзіце serverIp, спасылку на фармат: 1.1.1.1 або імя дамена",
    successxml: "Файл паспяхова прааналізаваны",
    groupCall: "групавы званок",
    groupCallTip:
      "Пасля яго ўключэння вы можаце выклікаць усе прылады ў групе, націснуўшы на значок групавога выкліку",
    record: "запіс версіі",
    export: "экспарт",
    sync: "Сінхранізаваць",
    communityTip:
      "У цяперашні час ёсць даныя прылады вобласці, пераключэнне ўзроўню зоны забаронена",
    areaNameTitle: "Апісанне іерархіі",
    noDataTip: "Нет данных",
    areaCodeDescriptionTip:
      "Описание области не может быть пустым, заполните его полностью",
    moduleName: "Инструмент настройки адресной книги",
    userSipAccount: "Номер зоны + серийный номер оборудования",
    devMax:
      "Узел устройства превысил лимит в 10000 записей, не удалось добавить",
    areaMax: "Узел области превысил лимит в 10000 записей, не удалось добавить",

    ipAndMaskTip1:
      "IP-адрес связан с маской подсети и должен удовлетворять бизнес-логике, чтобы результат побитового И не был полностью 1 или полностью 0",
    ipAndMaskTip2:
      "Если возникает ошибка правила проверки бизнес-логики, измените соответствующий IP-адрес",
    ipAndMaskTip3:
      "Неправильное правило проверки бизнес-логики для маски подсети и IP-адреса, измените IP-адрес",
    ipAndMaskTip4:
      "При массовом добавлении устройств IP, которые не соответствуют проверке бизнес-логики, будут автоматически пропущены",
    correctMaskTip: "Сначала введите правильную маску подсети",
    correctIpTip: "Введите правильный IP-адрес",
  },
  newDeviceType: {
    indoorMachine: "Внутренний блок",
    doorPhone: "Домофон",
    smallDoor: "Малый домофон",
    manage: "Управляющее устройство",
    wall: "Устройство на стене",
    monitor: "IP-камера",
    unitGuard: "Устройство управления блоком",
    networkCard: "Считыватель карт в сети",
    unitCard: "Считыватель карт блока",
    lift: "Модуль интеграции с лифтом",
    deviceTypeTip: "Пожалуйста, выберите тип устройства"
    }
};
